import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M6 20a2.893 2.893 0 0 1-2.125-.875A2.893 2.893 0 0 1 3 17H1V4h16v4h3l3 4v5h-2c0 .833-.292 1.542-.875 2.125A2.893 2.893 0 0 1 18 20a2.893 2.893 0 0 1-2.125-.875A2.893 2.893 0 0 1 15 17H9c0 .833-.292 1.542-.875 2.125A2.893 2.893 0 0 1 6 20m0-2a.97.97 0 0 0 .713-.288A.968.968 0 0 0 7 17a.968.968 0 0 0-.287-.712A.967.967 0 0 0 6 16a.967.967 0 0 0-.713.288A.968.968 0 0 0 5 17c0 .283.096.52.287.712.192.192.43.288.713.288m-3-3h.8c.283-.3.608-.542.975-.725A2.701 2.701 0 0 1 6 14c.45 0 .858.092 1.225.275.367.183.692.425.975.725H15V6H3zm15 3c.283 0 .52-.096.712-.288A.968.968 0 0 0 19 17a.968.968 0 0 0-.288-.712A.968.968 0 0 0 18 16a.968.968 0 0 0-.712.288A.968.968 0 0 0 17 17c0 .283.096.52.288.712A.965.965 0 0 0 18 18m-1-5h4.25L19 10h-2z" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }